import React, { useState, useEffect, useCallback, useRef } from 'react';
import { __ } from '@wordpress/i18n';

// api
import CompanyService from '../../../../service/company-service';
import BandoService from '../../../../service/bando-service';

// components
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import { isEmpty, pluck, uniq } from 'ramda';
import { classNames } from 'primereact/utils';
import { Editor } from 'primereact/editor';
import ChipsStandalone from '../../../../components/ChipsStandalone';
import { Toast } from 'primereact/toast';

const DialogPublishBando = ({
                                chosenCall = 0,
                                closeDialogCallback = () => {
                                }
                            }) => {
    const [loading, setLoading] = useState(false);
    const [isVisibleInviteDialog, setIsVisibleInviteDialog] = useState(false);
    const [companiesAvailable, setCompaniesAvailable] = useState([]);
    const [selectedToInvite, setSelectedToInvite] = useState([]);
    const [messageToInvite, setMessageToInvite] = useState('');
    const [selectedCategories, setSelectedCategories] = useState([]);
    const toast = useRef(null);

    const getCallback = (resp) => {
        if (resp.status === 'SUCCESS') {
            setCompaniesAvailable(resp.data.filter(o => !o.isAssociatedWithCall).map(o => o.company));
        }
        setLoading(false);
    }

    const errGetCallbacks = () => {
        setLoading(false);
    }

    const headerEditDialog = () => {
        return <span>{__('Pubblica e Invia', 'htr')}</span>
    }

    const hideEditDialog = () => {
        setIsVisibleInviteDialog(false);
        setSelectedToInvite([]);
        setMessageToInvite('');
        setSelectedCategories([]);
        closeDialogCallback();
    }

    const sendInvitations = useCallback(() => {
        if (!isEmpty(selectedToInvite)) {
            setLoading(true);
            const ids = pluck('id', selectedToInvite);
            const formData = {
                companyIds: ids,
                emailContent: messageToInvite
            };
            setSelectedToInvite([]);
            setMessageToInvite('');
            setSelectedCategories([]);
            BandoService.sendInvitesToCompanies(chosenCall, formData, getInvitesCallback, errGetInvitesCallbacks);
        }
    }, [selectedToInvite, messageToInvite]);

    const getInvitesCallback = (resp) => {
        if (resp.status === 'SUCCESS') {
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: '',
                    detail: resp.message
                });
            }
        }
        CompanyService.getCompaniesToInvite(chosenCall, getCallback, errGetCallbacks);
    }

    const errGetInvitesCallbacks = () => {
        setLoading(false);
    }

    const handleSelectionCategories = useCallback((ids) => {
        const newSelected = companiesAvailable.filter(o => ids.includes(o.lookUpDataId));
        setSelectedToInvite(newSelected);
        setSelectedCategories(ids);
    }, [companiesAvailable]);

    const handleSelectedToInvite = useCallback((companies) => {
        setSelectedToInvite(companies);
        const categoryIdsUsed = uniq(pluck('lookUpDataId', companies));
        setSelectedCategories(categoryIdsUsed);
    }, []);

    const footerEditDialog = useCallback(() => {
        return <div>
            <Button type="button" label={__('Annulla', 'htr')} onClick={hideEditDialog} outlined/>
            <Button
                type="button"
                disabled={loading || isEmpty(selectedToInvite)}
                label={__('Invia', 'htr')} onClick={sendInvitations}/>
        </div>
    }, [selectedToInvite, messageToInvite]);

    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
                <button className="ql-link" aria-label="Link"></button>
                <button className="ql-list" value="ordered"></button>
                <button className="ql-header" value="2"></button>
                <button className="ql-header" value="3"></button>
                <button className="ql-blockquote"></button>
                <button className="ql-list" value="bullet"></button>
                <button className="ql-indent" value="-1"></button>
                <button className="ql-indent" value="+1"></button>
            </span>
        );
    };

    const header = renderHeader();

    useEffect(() => {
        if (isVisibleInviteDialog) {
            setLoading(true);
            CompanyService.getCompaniesToInvite(chosenCall, getCallback, errGetCallbacks);
        }
    }, [isVisibleInviteDialog, chosenCall]);

    useEffect(() => {
        if (!chosenCall || chosenCall === 0) {
            setIsVisibleInviteDialog(false);
            setSelectedToInvite([]);
            setMessageToInvite('');
            setSelectedCategories([]);
            closeDialogCallback();
        } else {
            setIsVisibleInviteDialog(true);
        }
    }, [chosenCall]);

    return (
        chosenCall !== 0
            ? <>
                <Dialog
                    visible={isVisibleInviteDialog}
                    modal
                    header={headerEditDialog}
                    footer={footerEditDialog}
                    style={{ maxWidth: '600px', width: '100%' }}
                    onHide={hideEditDialog}>
                    <div className="appForm__field">
                        <ChipsStandalone
                            value={selectedCategories}
                            multiple={true}
                            label={__('Filtra per le categorie', 'htr')}
                            onChange={handleSelectionCategories}
                            disabled={loading}
                        />
                    </div>
                    <div className="appForm__field">
                        <label
                            className={classNames({ 'p-error': isEmpty(selectedToInvite) })}>
                            {__('Seleziona fornitori', 'htr')}*
                        </label>
                        <MultiSelect
                            value={selectedToInvite}
                            onChange={(e) => handleSelectedToInvite(e.value)}
                            options={companiesAvailable} optionLabel="companyName"
                            filter filterDelay={400} placeholder={__('Seleziona fornitori', 'htr')}
                            maxSelectedLabels={3}/>
                    </div>
                    <div className="appForm__field">
                        <label>
                            {__('Messaggio (opzionale)', 'htr')}
                        </label>
                        <div translate="no">
                            <Editor
                                value={messageToInvite}
                                readOnly={false}
                                placeholder={__('Digita qui il messagio', 'htr')}
                                headerTemplate={header}
                                onTextChange={(e) => setMessageToInvite(e.htmlValue)}
                                style={{ height: 80 * 3, width: '100%' }}
                            />
                        </div>
                    </div>
                </Dialog>
                <Toast ref={toast}/>
            </> : null
    )
}

export default DialogPublishBando;
